import { FAILURE, POST, SUCCESS, GET, PUT } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import { BASE_URL } from "../utils/const/base-url";
import { FORMATO_FECHA } from "../utils/const/formato-fecha";
import moment from "moment";

export async function obtenerListaCategoriaProducto(combo = false, tag) {
    try {
        let data = { error: true };
        const { status, body, message, } = await fetch(
            `${BASE_URL}/categoria/obtener-lista-categoria-productos`,
            {
                headers: getHeaders(false),
                method: GET,
                // body: JSON.stringify({ usuario, password }),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (status === SUCCESS) {
            data.error = false;
            data.body = body;
            if (combo === true) {
                data.body = data.body.map(item => ({
                    label: `${tag(item.descripcion)}`,
                    value: item.id,
                }));
            }
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
            data.body = null;
        }
        // console.log('data');
        // console.log(data);
        return data;
    } catch (err) {
        console.log("obtenerListaCategoriaProducto err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerListaCategoria(obj, combo = false, tag) {
    try {
        let data = { error: true };
        const { status, message, body } = await fetch(
            `${BASE_URL}/categoria/obtener-lista-categoria`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            data.data = body;
            if (combo === true) {
                data.data = data.data.map(item => ({
                    label: `${item.codigo} - ${item.descripcion}`,
                    value: item.id,
                }));
            }
            if (combo === false) {
                data.data = data.data.map(item => ({
                    ...item,
                    habilitadoLabel: item.habilitado ? tag("label_habilitado") : tag("label_deshabilitado"),
                    fechaProceso: moment(item.fechaProceso).format(FORMATO_FECHA.YYYY_MM_DD_HH_MM_SS),
                }));
            }
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerListaCategoria err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function crearCategoria(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/categoria/crear-categoria`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearCategoria err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function modificarCategoria(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/categoria/modificar-categoria`,
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("modificarCategoria err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarCategoria(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/categoria/deshabilitar-categoria`,
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("deshabilitarCategoria err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function habilitarCategoria(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/categoria/habilitar-categoria`,
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("habilitarCategoria err");
        console.log(err);
        return { error: true, message: err };
    }
}